import React from 'react';
import { ChecklistItem } from '../types';

interface ChecklistProps {
  items: ChecklistItem[];
}

const Checklist: React.FC<ChecklistProps> = ({ items }) => {
  return (
    <div className="flex flex-col gap-3 mt-2">
      {items.map((item, index) => (
        <div
          key={index}
          className={`
            relative p-4 rounded-xl border transition-all
            ${item.met 
              ? 'bg-emerald-50 border-emerald-100' 
              : 'bg-red-50 border-red-100'}
          `}
        >
          <div className="flex justify-between items-start mb-2">
            <span className={`text-xs font-bold uppercase tracking-wider ${item.met ? 'text-emerald-600' : 'text-red-600'}`}>
              {item.label}
            </span>
            <div className={`
              rounded-full p-1 
              ${item.met ? 'bg-emerald-200 text-emerald-700' : 'bg-red-200 text-red-700'}
            `}>
              {item.met ? (
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
                </svg>
              ) : (
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              )}
            </div>
          </div>
          <p className={`text-sm leading-snug ${item.met ? 'text-emerald-800' : 'text-red-800'}`}>
            {item.explanation}
          </p>
        </div>
      ))}
    </div>
  );
};

export default Checklist;